import { createContext } from 'react';
export const defaultValue = {
    breakpoint: {},
};
export const BreakpointProviderContext = createContext(defaultValue);
